import { render, staticRenderFns } from "./CvLanguage.vue?vue&type=template&id=da9a0856&scoped=true"
import script from "./CvLanguage.vue?vue&type=script&lang=js"
export * from "./CvLanguage.vue?vue&type=script&lang=js"
import style0 from "./CvLanguage.vue?vue&type=style&index=0&id=da9a0856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9a0856",
  null
  
)

export default component.exports